/* Email-gated free guide download — captures a lead, then triggers the PDF. */
import React, { useState } from 'react';
import { Download, Loader2, Check, Share2 } from 'lucide-react';
import { api } from '@/lib/api';
import { trackEvent } from '@/lib/analytics';

const PDF = '/downloads/SMI-Automation-Guide.pdf';

export const GuideDownload = ({ from, compact, file = PDF, label = 'FREE GUIDE (PDF)' }) => {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [state, setState] = useState('idle');
    const unlocked = typeof window !== 'undefined' && localStorage.getItem('smi_guide_unlocked') === '1';
    const fire = () => { const a = document.createElement('a'); a.href = file; a.download = file.split('/').pop(); a.click(); };
    const submit = async (e) => {
        e.preventDefault();
        const em = email.trim();
        if (!/^\S+@\S+\.\S+$/.test(em)) { setState('invalid'); return; }
        setState('sending');
        trackEvent('brochure_download', { from, gated: true });
        try {
            await api.post('/automation-center/leads', { name: em.split('@')[0], email: em, company: '', hp_field: '', goals: ['Free guide download'], notes: `FREE GUIDE DOWNLOAD (${from})`, source_page: from });
        } catch { /* still deliver the guide */ }
        localStorage.setItem('smi_guide_unlocked', '1');
        setState('done');
        fire();
    };
    const [copied, setCopied] = useState(false);
    const shareLink = () => {
        navigator.clipboard.writeText(`${window.location.origin}/api/share/guide`).catch(() => {});
        trackEvent('brochure_share_link', { from });
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    if (unlocked || state === 'done') {
        return (
            <span className="inline-flex items-center gap-2 flex-wrap">
                <button data-testid={`guide-dl-${from}`} onClick={() => { trackEvent('brochure_download', { from, gated: false }); fire(); }}
                    className={compact ? 'lab-mono text-[9px] text-lab-emerald hover:text-white inline-flex items-center gap-1' : 'lab-mono text-[11px] tracking-[0.14em] px-6 py-3 rounded-full border border-lab-emerald/50 text-lab-emerald hover:bg-lab-emerald/10 inline-flex items-center gap-1.5'}>
                    <Check className="w-3 h-3" /> {label} ↓
                </button>
                {!compact && file === PDF && (
                    <button data-testid={`guide-share-${from}`} onClick={shareLink} title="Copy shareable link (rich preview for LinkedIn/X)"
                        className="lab-mono text-[10px] px-4 py-3 rounded-full border border-white/15 text-lab-mute hover:text-white hover:border-lab-emerald/40 inline-flex items-center gap-1.5">
                        {copied ? <Check className="w-3 h-3 text-lab-emerald" /> : <Share2 className="w-3 h-3" />} {copied ? 'LINK COPIED' : 'SHARE'}
                    </button>
                )}
            </span>
        );
    }
    if (!open) {
        return (
            <button data-testid={`guide-open-${from}`} onClick={() => setOpen(true)}
                className={compact ? 'lab-mono text-[9px] text-lab-emerald hover:text-white inline-flex items-center gap-1' : 'lab-mono text-[11px] tracking-[0.14em] px-6 py-3 rounded-full border border-lab-emerald/50 text-lab-emerald hover:bg-lab-emerald/10 inline-flex items-center gap-1.5'}>
                <Download className="w-3 h-3" /> {label}
            </button>
        );
    }
    return (
        <form onSubmit={submit} noValidate className="flex gap-2 items-center flex-wrap" data-testid={`guide-form-${from}`}>
            <input data-testid={`guide-email-${from}`} type="email" value={email} onChange={(e) => { setEmail(e.target.value); setState('idle'); }} placeholder="you@company.com" autoFocus
                className="bg-white/5 border border-lab-emerald/40 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-lab-dim outline-none focus:border-lab-emerald w-56" />
            <button data-testid={`guide-send-${from}`} type="submit" disabled={state === 'sending'}
                className="lab-mono text-[10px] px-5 py-2.5 rounded-full bg-lab-emerald text-black font-semibold hover:brightness-110 disabled:opacity-50 inline-flex items-center gap-1.5">
                {state === 'sending' ? <Loader2 className="w-3 h-3 animate-spin" /> : <Download className="w-3 h-3" />} GET THE GUIDE
            </button>
            {state === 'invalid' && <span className="text-lab-pink text-xs" data-testid={`guide-err-${from}`}>Enter a valid email.</span>}
        </form>
    );
};
